/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import * as React from 'react';
import { ACCESSIBILITY_TYPE, PLACEMENT, TRIGGER_TYPE } from './constants';
import baseDefaultProps from './default-props';
import StatefulContainer from './stateful-tooltip-container';
import Tooltip from './tooltip';
import type { StatefulTooltipProps } from './types';
function StatefulTooltip(props: StatefulTooltipProps) {
  const {
    children,
    accessibilityType = ACCESSIBILITY_TYPE.tooltip,
    focusLock = false,
    autoFocus = false,
    returnFocus = false,
    onMouseEnterDelay = baseDefaultProps.onMouseEnterDelay,
    onMouseLeaveDelay = baseDefaultProps.onMouseLeaveDelay,
    overrides = {},
    placement = PLACEMENT.auto,
    popoverMargin = 0,
    showArrow = false,
    triggerType = TRIGGER_TYPE.hover,
    renderAll = false,
    ...restProps
  } = props;
  return <StatefulContainer accessibilityType={accessibilityType} focusLock={focusLock} autoFocus={autoFocus} returnFocus={returnFocus} onMouseEnterDelay={onMouseEnterDelay} onMouseLeaveDelay={onMouseLeaveDelay} overrides={overrides} placement={placement} popoverMargin={popoverMargin} showArrow={showArrow} triggerType={triggerType} renderAll={renderAll} {...restProps}>
      {tooltipProps => <Tooltip {...tooltipProps}>{children}</Tooltip>}
    </StatefulContainer>;
}
export default StatefulTooltip;